/* global BAKED_APPLICATION_VERSION */
import semver from 'semver';

const applicationVersion = BAKED_APPLICATION_VERSION;
const parsedSemver = semver.parse(applicationVersion);

export default {
  version: applicationVersion,
  reportVersion() {
    /* eslint no-console: 0 */
    console.log(`Viddsee Creator version: ${applicationVersion} (${process.env.NODE_ENV})`);
  },
  injectVersion(injectionTarget = window) {
    const { major = 0, minor = 0, patch = 0 } = parsedSemver || {};
    const versionSum = (0
      + (major * 1000000)
      + (minor * 1000)
      + (patch * 1)
    );

    injectionTarget.version = {
      version: applicationVersion,
      versionSum,
    };
  },
};



// WEBPACK FOOTER //
// ./src/utils/versionReporter.js